// extracted by mini-css-extract-plugin
export default {"labelSection":"styles_labelSection__B2eJT"};